import VForm from "@/vuetify_custom/v-form";
import VTable from "@/vuetify_custom/v-table/v3";
import VModel from "@/vuetify_custom/v-modal_v1";
import { commonValidateRule } from "@/libs/rules_utils.js";
import { TEXT_FIELD, DIST_PICKER } from "@/vuetify_custom/v-form/type_name";

import {
  getThirdPartyMallAvailableStockNumApi,
  getSellDeliverOrderDetailApi,
  getSellOrderDetailApi,
} from "./services";
import NumberField from "@/vuetify_custom/v-form/components/Number_Field.js";
import { SellTypeMap, ResellShopWarehouseHash } from "./constants";
import { getDeliveryWarehouseName } from "@/libs/delivery_warehouse";
const commonValidateRuleT = commonValidateRule("必填");

function createDeliverOrders(sellOrder, deliverOrder) {
  if (!deliverOrder.id) {
    return sellOrder?.sell_order_items?.map((item) => {
      return {
        contract_product_price_info_id: item.product_price_info.id,
        sell_order_item_id: item.id,
        item_id: item.item_id,
        sub_item_id: item.sub_item_id,
        stock_id: item.stock_id,
        stock_code: item.stock_code,
        stock_name: item.stock_name,
        sell_type: item.sell_type,
        price: item.price,
        tax_rate: item.tax_rate,
        quantity: 0,
        // 额外信息，仅做展示
        delivered_quantity: item.delivered_quantity,
        order_quantity: item.quantity,
      };
    });
  } else {
    return deliverOrder.sell_deliver_order_items.map((item) => {
      const sellOrderItem = sellOrder.sell_order_items.find(
        (item1) => item1.id === item.sell_order_item_id
      );
      return {
        ...item,
        delivered_quantity: sellOrderItem.delivered_quantity,
        order_quantity: sellOrderItem.quantity,
      };
    });
  }
}

function createParams(params, sellOrder) {
  const resellShopWarehouse = ResellShopWarehouseHash[sellOrder?.shop_id] || {};
  return {
    id: params?.id || null,
    uid: params?.uid || null,
    contract_id: params?.contract_id || sellOrder?.contract_id || null,
    sell_order_id: params?.sell_order_id || sellOrder?.id || null,
    payee_company_name:
      params?.payee_company_name || sellOrder?.payee_company_name || null,
    name: params?.name || null,
    recv_user: params?.recv_user || null,
    recv_contact: params?.recv_contact || null,
    province: params?.province || null,
    city: params?.city || null,
    area: params?.area || null,
    recv_detail_address: params?.recv_detail_address || null,
    memo: params?.memo || null,
    sell_deliver_order_items: createDeliverOrders(sellOrder, params),

    // 额外信息，仅做展示
    sell_order_uid: sellOrder?.uid || null,
    parent_shop_name: resellShopWarehouse.shop_name || "-",
    parent_warehouse_name:
      resellShopWarehouse.warehouse_name ||
      getDeliveryWarehouseName(sellOrder?.warehouse_code),
  };
}

export default {
  data() {
    return {
      dis: false,
      submitLoading: false,
      loading: false,
      params: createParams({}, {}),
      stockAmountHash: {},
      sellOrder: null,
    };
  },
  computed: {
    baseInfoFields() {
      // const _this = this;
      // const d = [(val) => !!val || "必选"];
      const arr = [
        {
          label: "渠道",
          key: "payee_company_name",
          type: TEXT_FIELD,
          disabled: true,
        },
        {
          label: "订单编号",
          type: TEXT_FIELD,
          key: "sell_order_uid",
          cols: 12,
          disabled: true,
        },
        {
          label: "发货通知号",
          type: TEXT_FIELD,
          key: "uid",
          cols: 12,
          disabled: true,
        },
        {
          label: "发货店铺",
          key: "parent_shop_name",
          type: TEXT_FIELD,
          cols: 12,
          disabled: true,
        },
        {
          label: "发货仓",
          key: "parent_warehouse_name",
          type: TEXT_FIELD,
          cols: 12,
          disabled: true,
        },
        {
          label: "收货人",
          type: "text_field",
          key: "recv_user",
          cols: 12,
          inline: true,
          row: true,
          rules: [commonValidateRuleT],
          disabled: true,
        },
        {
          label: "收货人手机号",
          key: "recv_contact",
          type: "text_field",
          cols: 12,
          inline: true,
          row: true,
          rules: [commonValidateRuleT],
          disabled: true,
        },
        {
          label: "省市",
          type: DIST_PICKER,
          key: "name",
          // province_key: "province",
          // city_key: "city",
          // area_key: "area",
          province_name_key: "province",
          city_name_key: "city",
          area_name_key: "area",
          cols: 12,
          required: true,
          rules: [commonValidateRuleT],
          disabled: true,
        },
        {
          label: "详细地址",
          key: "recv_detail_address",
          type: "text_field",
          cols: 12,
          inline: true,
          row: true,
          rules: [commonValidateRuleT],
          disabled: true,
        },
        {
          label: "订单备注",
          type: "text_field",
          key: "memo",
          cols: 12,
          disabled: true,
        },
        {
          key: "table",
          cols: 12,
        },
      ];
      return arr.filter((item) => !item.hide);
    },
    table_fields() {
      // const _this = this;
      return [
        {
          text: "sku代码",
          align: "center",
          value: "stock_code",
          width: 150,
        },
        {
          text: "sku名称",
          align: "center",
          value: "stock_name",
          width: 150,
        },
        {
          text: "销售类型",
          align: "center",
          value: "sell_type",
          width: 150,
          render: (_, item) => {
            return <span>{SellTypeMap[item.sell_type] || "-"}</span>;
          },
        },
        {
          text: "订单数量",
          align: "center",
          value: "order_quantity",
          width: 150,
        },
        {
          text: "已发数量",
          align: "center",
          value: "delivered_quantity",
          width: 150,
        },
        {
          text: "剩余待发",
          align: "center",
          value: "remaining_quantity",
          width: 150,
          render: (_, item) => {
            return (
              <span>
                {math
                  .eval(`${item.order_quantity}-${item.delivered_quantity}`)
                  .toFixed(0) || 0}
              </span>
            );
          },
        },
        {
          text: "可用库存",
          align: "center",
          value: "available_stock",
          width: 150,
          render: (_, item) => {
            return <span>{this.stockAmountHash[item.stock_code] || 0}</span>;
          },
        },
        {
          text: "本次发货数量",
          align: "center",
          value: "quantity",
          width: 150,
          render: (_, item) => {
            return (
              <NumberField
                v-model={item}
                field={{
                  key: "quantity",
                  change: () => {},
                  disabled: true,
                  rules: [
                    (val) => {
                      if (
                        Number(val) >
                        Number(this.stockAmountHash[item.stock_code])
                      ) {
                        return "可用库存不足";
                      }
                      if (Number(val) < 0) {
                        return "数量不能小于0";
                      }
                      if (Number(val) > Number(item.order_quantity)) {
                        return "数量不能大于订单数量";
                      }
                      // 不可以输入小数
                      if (Number(val) % 1 !== 0) {
                        return "数量不能输入小数";
                      }
                      return true;
                    },
                  ],
                }}
              />
            );
          },
        },
      ];
    },
    sellOrderItems() {
      return this.sellOrder?.sell_order_items || [];
    },
  },
  watch: {
    sellOrderItems: {
      handler(newVal) {
        if (newVal.length) {
          const codes = newVal.map((item) => item.stock_code).join(",");
          this.getStockAmount(codes);
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    open(sellOrderId, deliverOrderId) {
      this.dis = true;
      this.loading = true;
      Promise.all([
        getSellOrderDetailApi({ id: sellOrderId }),
        getSellDeliverOrderDetailApi({ id: deliverOrderId }),
      ])
        .then(([sellOrder, deliverOrder]) => {
          this.sellOrder = sellOrder;
          this.params = createParams(deliverOrder, sellOrder);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit() {
      this.close();
    },
    close() {
      this.dis = false;
      this.$emit("close");
    },
    /**
     * 获取外部sku库存
     */
    getStockAmount(codes) {
      const warehouse_code = this.sellOrder?.warehouse_code;
      if (!warehouse_code) {
        this.stockAmountHash = {};
        return;
      }
      getThirdPartyMallAvailableStockNumApi({
        stock_codes: codes,
        warehouse_code,
      }).then(
        (res) => {
          console.log("res", res);
          if (Array.isArray(res)) {
            res.forEach((item) => {
              this.stockAmountHash[item.sku_code] = item.available_stock_num;
            });
            this.$forceUpdate();
          }
        }
      );
    },
  },
  render() {
    return (
      <VModel
        fullscreen
        v-model={this.dis}
        persistent
        dynamic-height
        height-rate={0.7}
        title={"发货通知详情"}
        loading={this.submitLoading}
        on={{
          ok: this.submit,
          cancel: this.close,
        }}
      >
        <VForm
          ref="base"
          v-model={this.params}
          fields={this.baseInfoFields}
          scopedSlots={{
            table: () => {
              return (
                <div>
                  <VTable
                    headers={[...this.table_fields]}
                    desserts={this.params.sell_deliver_order_items}
                  />
                </div>
              );
            },
          }}
        />
      </VModel>
    );
  },
};
